import * as React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Button, Container, Grid, Typography } from '@material-ui/core';
import { useRouter } from 'next/router';

const useStyles = makeStyles((theme) =>
  createStyles({
    errorTextStyle: {
      fontSize: 90,
      letterSpacing: 8,
      [ theme.breakpoints.down('sm') ]: {
        fontSize: '45px',
      },
    },
    mt20: {
      marginTop: 20,
    },
    pt15: {
      paddingTop: '15%',
    },
    textCenter: {
      textAlign: 'center'
    },
    textLightBlack: {
      color: '#858585',
      fontFamily: 'sans-serif',
    }
  }),
);

export default function createAgentPopupClose() {
  const router = useRouter();
  const classes = useStyles();

  const agentSigningIn = async () => {
    if (typeof Window !== 'undefined') {
      const confirmElemId = 'viewer_iframe_confirm';
      let confirmBtn: any = parent.document.getElementById(confirmElemId);
      const elemId = 'viewer_iframe';
      let iFrame: any = parent.document.getElementById(elemId);
      confirmBtn && confirmBtn.click();
      iFrame && iFrame.remove();
    }
  };

  const firstRun = () => {
    if (router.query && router.query.event === 'signing_complete') {
      agentSigningIn()
    }
  };

  React.useEffect(firstRun, [router.query]);

  return (
    <Container maxWidth="md" className={classes.pt15}>
      <Grid container spacing={3} alignItems="center">
        <Grid item xs={12} md={12} className="textCenter" alignContent="center">
          <Typography variant="h1" className={classes.errorTextStyle} color="primary">Thank You!</Typography>
          <Typography variant="subtitle2" className={classes.textLightBlack} color="primary">
            Agreement Signed Successfully! You shall be redirected automatically. If the page doesn't refresh, Please
            click button below.
          </Typography>
          <Button className={classes.mt20} color="primary" onClick={agentSigningIn} size="small" variant="contained">
            Click to close and continue
          </Button>
        </Grid>
      </Grid>
    </Container>
  )
};
